import { IContainer } from '../../interface/container';
import { IUserStateInstantiator } from '../interface/userstate';
import userState from './userState';

function bind(container: IContainer): IUserStateInstantiator {
    return {
        open: (name: string) => userState.load(name),
        expand: (data: string) => userState.expand(data),
    };
}

export default bind;
